// import { forwardRef, useEffect, useRef, useState } from "react";
// import styles from "../../../pages/ordermanager/Orders.module.css";
// import { CloseIcon, TemplateNotFound } from "../../icons/Icon2";
// import SlidingFilter2 from "../Dealers/SlidingFilter2";
// import NoDataFound from "../NoDataFound/NoDataFound";
// import { Dispatch } from "../../icons/Icon";

// const ProSaleShippingChargesInfoModal = forwardRef(
//   (
//     {
//       mode,
//       handleCloseModal,
//       shippingType,
//       itemDetails,
//       shippingInfo,
//       setShippingInfo,
//       dw,
//     },
//     ref,
//   ) => {
//     // ── Guard: this modal can be opened with shippingInfo not yet set
//     //    (e.g. right after picking a delivery method); never let a
//     //    downstream .find()/.map() throw on undefined ────────────────────
//     const safeShippingInfo = Array.isArray(shippingInfo) ? shippingInfo : [];
//     const safeDw = dw || { label: "", value: "" };

//     /* -------------------- Warehouses -------------------- */
//     const uniqueWarehouses = itemDetails
//       .filter((i) => i.warehouse && i.warehouseId)
//       .reduce((acc, item) => {
//         if (!acc.find((w) => w.warehouseId === item.warehouseId)) {
//           acc.push({
//             warehouse: item.warehouse,
//             warehouseId: item.warehouseId,
//           });
//         }
//         return acc;
//       }, []);

//     const warehouseDisplayList = uniqueWarehouses.map((w) => ({
//       id: w.warehouseId,
//       label: w.warehouse,
//     }));

//     const getWarehouseIndexById = (id) =>
//       uniqueWarehouses.findIndex((w) => w.warehouseId === id);

//     /* -------------------- State -------------------- */
//     const [selectedWarehouse, setSelectedWarehouse] = useState(() => {
//       const first = uniqueWarehouses[0];
//       return first
//         ? { label: first.warehouse, value: first.warehouseId }
//         : { label: "", value: "" };
//     });

//     const [inputValue, setInputValue] = useState("");
//     const [isSelfMethod, setIsSelfMethod] = useState(false);
//     const inputRef = useRef(null);

//     /* -------------------- Effects -------------------- */
//     useEffect(() => {
//       inputRef.current?.focus();
//     }, [selectedWarehouse]);

//     useEffect(() => {
//       const data =
//         shippingType === "Combined"
//           ? safeShippingInfo.find((w) => w.isDispatchWarehouse)
//           : safeShippingInfo.find(
//               (w) => w.warehouseId === selectedWarehouse.value,
//             );

//       setIsSelfMethod(data?.methodName === "Self");
//       setInputValue(
//         data?.shippingCharge === 0 || data?.shippingCharge
//           ? data.shippingCharge
//           : "",
//       );
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [shippingType, selectedWarehouse, shippingInfo]);

//     /* -------------------- Handlers -------------------- */
//     const warehouseChange = (warehouseId) => {
//       const w = uniqueWarehouses.find((x) => x.warehouseId === warehouseId);
//       if (!w) return;

//       setSelectedWarehouse({ label: w.warehouse, value: w.warehouseId });

//       const data = safeShippingInfo.find((s) => s.warehouseId === warehouseId);
//       setIsSelfMethod(data?.methodName === "Self");
//       setInputValue(
//         data?.shippingCharge === 0 || data?.shippingCharge
//           ? data.shippingCharge
//           : "",
//       );
//     };

//     // ── FIX: allow the field to be genuinely blank while typing instead
//     //    of collapsing to "0" (that was the "wrong value in the modal"
//     //    behaviour) — only coerce to a number once there's real input ──
//     const handleChange = (e) => {
//       if (isSelfMethod) return;

//       const rawValue = e.target.value;

//       if (rawValue === "") {
//         setInputValue("");
//         setShippingInfo((prev) =>
//           (prev || []).map((item) =>
//             item.warehouseId ===
//             (shippingType === "Combined"
//               ? safeDw.value
//               : selectedWarehouse.value)
//               ? { ...item, shippingCharge: 0 }
//               : item,
//           ),
//         );
//         return;
//       }

//       const parsed = parseInt(rawValue, 10);
//       const finalValue = Math.max(0, isNaN(parsed) ? 0 : parsed);

//       setInputValue(finalValue);

//       setShippingInfo((prev) =>
//         (prev || []).map((item) =>
//           item.warehouseId ===
//           (shippingType === "Combined" ? safeDw.value : selectedWarehouse.value)
//             ? { ...item, shippingCharge: finalValue }
//             : item,
//         ),
//       );
//     };

//     const handleKeyDown = (e) => {
//       if (e.key !== "Enter") return;

//       if (shippingType === "Combined") {
//         handleCloseModal();
//         requestAnimationFrame(() => ref?.current?.focus());
//         return;
//       }

//       const currentIndex = getWarehouseIndexById(selectedWarehouse.value);

//       if (currentIndex < uniqueWarehouses.length - 1) {
//         const next = uniqueWarehouses[currentIndex + 1];
//         warehouseChange(next.warehouseId);
//       } else {
//         handleCloseModal();
//         requestAnimationFrame(() => ref?.current?.focus());
//       }
//     };

//     const isValidItem = (item) => {
//       return !(
//         item.amount === 0 &&
//         item.price === 0 &&
//         item.qty === 0 &&
//         item.dp === 0 &&
//         item.vm === 0 &&
//         item.weight === 0 &&
//         item.totalQty === "" &&
//         item.product_name === "" &&
//         item.itemNo === "" &&
//         item.collection_name === ""
//       );
//     };

//     /* -------------------- Calculations -------------------- */
//     const filteredItems =
//       shippingType === "Separate"
//         ? itemDetails.filter(
//             (i) => i.warehouseId === selectedWarehouse.value && isValidItem(i),
//           )
//         : itemDetails.filter(isValidItem);

//     const totalCBM = filteredItems.reduce(
//       (s, i) => s + Number(i.vm || 0) * i.qty,
//       0,
//     );

//     const totalWeight = filteredItems.reduce(
//       (s, i) => s + Number(i.weight || 0) * i.qty,
//       0,
//     );

//     /* -------------------- Styles -------------------- */
//     const liStyles = {
//       backgroundColor: mode ? "#2C2E33" : "#D9DCE5",
//       color: mode ? "#FFFFFF" : "#646B88",
//       fontWeight: "600",
//     };

//     const IPSLiStyles = {
//       color: mode ? "#FFFFFF" : "#646B88",
//       backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
//     };

//     /* -------------------- UI -------------------- */
//     return (
//       <div
//         className={styles.sci_modal}
//         style={{ backgroundColor: mode && "#232529" }}
//       >
//         <div className={styles.modal_header}>
//           <p style={{ color: mode && "#fff" }}>Shipping Charges Info</p>

//           {shippingType === "Separate" && (
//             <SlidingFilter2
//               itemList={warehouseDisplayList.map((w) => w.label)}
//               selectedItem={selectedWarehouse.label}
//               setFilter={(label) => {
//                 const found = warehouseDisplayList.find(
//                   (w) => w.label === label,
//                 );
//                 found && warehouseChange(found.id);
//               }}
//               enableKeyboardNavigation
//             />
//           )}

//           <div onClick={handleCloseModal}>
//             <CloseIcon mode={mode} />
//           </div>
//         </div>

//         {!itemDetails.length ? (
//           <NoDataFound
//             icon={<TemplateNotFound />}
//             textTitle="No items to calculate shipping charges"
//           />
//         ) : (
//           <>
//             <ul className={styles.sc_data}>
//               <li style={liStyles}>
//                 <div>Item</div>
//                 <div>Warehouse</div>
//                 <div>Quantity</div>
//                 <div>Volume(CBM)</div>
//                 <div>Weight(KG)</div>
//                 <div>Shipping Charge</div>
//               </li>

//               <div className={styles.sc_data_scroll}>
//                 {filteredItems.map((item, i) => (
//                   <li style={IPSLiStyles} key={i}>
//                     <div>{item.itemNo}</div>
//                     <div>
//                       {item.warehouse}
//                       {item.warehouseId === safeDw.value && <Dispatch />}
//                     </div>
//                     <div>{item.qty}</div>
//                     <div>{item.vm}</div>
//                     <div>{item.weight}</div>
//                     <div></div>
//                   </li>
//                 ))}
//               </div>

//               <li style={liStyles}>
//                 <div>Total</div>
//                 <div />
//                 <div />
//                 <div>{totalCBM.toFixed(2)}</div>
//                 <div>{totalWeight.toFixed(2)}</div>
//                 <div>
//                   <input
//                     ref={inputRef}
//                     type="number"
//                     // ── FIX: was `Number(inputValue).toString()`, which
//                     //    forced a blank value to display as "0" and made
//                     //    it impossible to clear the field ────────────────
//                     value={inputValue === "" ? "" : inputValue}
//                     onChange={handleChange}
//                     onKeyDown={handleKeyDown}
//                     disabled={isSelfMethod}
//                     className={styles.sc_inp}
//                     style={{ color: mode && "#FFFFFF" }}
//                     onFocus={(e) => e.target.select()}
//                   />
//                 </div>
//               </li>
//             </ul>
//           </>
//         )}
//       </div>
//     );
//   },
// );

// export default ProSaleShippingChargesInfoModal;
import { forwardRef, useEffect, useRef, useState } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CloseIcon, TemplateNotFound } from "../../icons/Icon2";
import NoDataFound from "../NoDataFound/NoDataFound";

/**
 * Single-warehouse / single-shippingInfo-object model.
 * shippingInfo is now ONE object, not a per-warehouse array — so there's
 * no more warehouse SlidingFilter2, no `dw`, no `selectedWarehouse`. Just
 * one charge field for the whole voucher.
 */
const ProSaleShippingChargesInfoModal = forwardRef(
  (
    {
      mode,
      handleCloseModal,
      itemDetails,
      shippingInfo,
      setShippingInfo,
      generalInfo,
    },
    ref,
  ) => {
    const safeShippingInfo = shippingInfo || {};
    const isSelfMethod = safeShippingInfo?.methodName === "Self";

    const [inputValue, setInputValue] = useState(
      safeShippingInfo?.shippingCharge === 0 || safeShippingInfo?.shippingCharge
        ? safeShippingInfo.shippingCharge
        : "",
    );
    const inputRef = useRef(null);

    useEffect(() => {
      inputRef.current?.focus();
    }, []);

    // ── Allow the field to be genuinely blank while typing instead of
    //    collapsing to "0" — only coerce to a number once there's real
    //    input, and write straight into the single shippingInfo object. ──
    const handleChange = (e) => {
      if (isSelfMethod) return;

      const rawValue = e.target.value;

      if (rawValue === "") {
        setInputValue("");
        setShippingInfo((prev) => ({ ...(prev || {}), shippingCharge: 0 }));
        return;
      }

      const parsed = parseInt(rawValue, 10);
      const finalValue = Math.max(0, isNaN(parsed) ? 0 : parsed);

      setInputValue(finalValue);
      setShippingInfo((prev) => ({
        ...(prev || {}),
        shippingCharge: finalValue,
      }));
    };

    const handleKeyDown = (e) => {
      if (e.key !== "Enter") return;
      handleCloseModal();
      requestAnimationFrame(() => ref?.current?.focus());
    };

    const isValidItem = (item) => {
      return !(
        item.amount === 0 &&
        item.price === 0 &&
        item.qty === 0 &&
        item.dp === 0 &&
        item.vm === 0 &&
        item.weight === 0 &&
        item.totalQty === "" &&
        item.product_name === "" &&
        item.itemNo === "" &&
        item.collection_name === ""
      );
    };

    const filteredItems = itemDetails.filter(isValidItem);

    const totalCBM = filteredItems.reduce(
      (s, i) => s + Number(i.vm || 0) * i.qty,
      0,
    );

    const totalWeight = filteredItems.reduce(
      (s, i) => s + Number(i.weight || 0) * i.qty,
      0,
    );

    const liStyles = {
      backgroundColor: mode ? "#2C2E33" : "#D9DCE5",
      color: mode ? "#FFFFFF" : "#646B88",
      fontWeight: "600",
    };

    const IPSLiStyles = {
      color: mode ? "#FFFFFF" : "#646B88",
      backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
    };

    return (
      <div
        className={styles.sci_modal}
        style={{ backgroundColor: mode && "#232529" }}
      >
        <div className={styles.modal_header}>
          <p style={{ color: mode && "#fff" }}>Shipping Charges Info</p>

          <div onClick={handleCloseModal}>
            <CloseIcon mode={mode} />
          </div>
        </div>

        {!itemDetails.length ? (
          <NoDataFound
            icon={<TemplateNotFound />}
            textTitle="No items to calculate shipping charges"
          />
        ) : (
          <>
            <ul className={styles.sc_data}>
              <li style={liStyles}>
                <div>Item</div>
                <div>Warehouse</div>
                <div>Quantity</div>
                <div>Volume(CBM)</div>
                <div>Weight(KG)</div>
                <div>Shipping Charge</div>
              </li>

              <div className={styles.sc_data_scroll}>
                {filteredItems.map((item, i) => (
                  <li style={IPSLiStyles} key={i}>
                    <div>{item.itemNo}</div>
                    <div>{item.warehouse || generalInfo?.warehousename}</div>
                    <div>{item.qty}</div>
                    <div>{item.vm}</div>
                    <div>{item.weight}</div>
                    <div></div>
                  </li>
                ))}
              </div>

              <li style={liStyles}>
                <div>Total</div>
                <div />
                <div />
                <div>{totalCBM.toFixed(2)}</div>
                <div>{totalWeight.toFixed(2)}</div>
                <div>
                  <input
                    ref={inputRef}
                    type="number"
                    value={inputValue === "" ? "" : inputValue}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    disabled={isSelfMethod}
                    className={styles.sc_inp}
                    style={{ color: mode && "#FFFFFF" }}
                    onFocus={(e) => e.target.select()}
                  />
                </div>
              </li>
            </ul>
          </>
        )}
      </div>
    );
  },
);

export default ProSaleShippingChargesInfoModal;
